export default __webpack_public_path__ + "static/media/upsell-hero.835fb9a0.svg";